module.exports = __webpack_public_path__ + "static/Tunku-Nafishah-ec5479687ba4af36ebdd28b902497a50.jpeg";